import script from "./UploadList.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadList.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/pc/addUpload.css?vue&type=style&index=0&id=f54f83ae&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f54f83ae"]])

export default __exports__